import StoreKit from '@bfe/by-idb-store';

const moduleName = 'BY_IDB_STORE';


export class RequestError extends Error {
  code: number;
  originalResponse: Record<string, any> | undefined;
  url: string | undefined;
  response: any;
  constructor(
    message: string,
    code: number,
    originalResponse?: Record<string, any>,
    url?: string
  ) {
    super(message);
    this.code = code;
    this.originalResponse = originalResponse;
    this.url = url;
  }
}

export enum EnumCacheErrorCode {
  /**
   * by-idb-store 库在设置缓存时出错
   */
  IDB_CACHE_SET_ERROR = 20000,
  /**
   * by-idb-store 库在获取缓存时出错
   */
  IDB_CACHE_GET_ERROR = 30000,
  /**
   * by-idb-store 库获取的缓存数据为 undefined
   */
  IDB_CACHE_GET_UNDEFINED_ERROR = 30001
}

export const storeKit = new StoreKit({
  dbName: 'SPOT_FE_PREMARKET_CACHE_DB',
  version: 1
});

export interface ReportErrorInfo {
  retry_reason: string;
  event_name: string;
  retry_path: string;
}


function reportError(error: ReportErrorInfo): void {
  // 检查Monitor是否存在并且有log方法
  if ((window as any).Monitor && typeof (window as any).Monitor.log === 'function') {
    try {
      const data = JSON.parse(JSON.stringify(error));
      // 尝试发送上报
      (window as any).Monitor.log(data)
    } catch (error) {
      // 处理log方法可能抛出的错误
      console.error('Error logging event:', error);
    }
  } else {
    // 若Monitor不存在或log方法不可用，记录到控制台
    console.warn('Monitor.log is not available.');
  }
}

function isHttpError(err: RequestError): boolean {
  return (
    err.code === 429 ||err.code >= 500
  ) as boolean;
}

function isServerError(error: any): boolean {
  return error?.code === 10016 || error?.code === 10006 || error?.code === 501;
}

// function isErrorNetwork(error: any): boolean {
//   return error.code === 'ERR_NETWORK';
// }

async function setCache(key: string, value: any): Promise<void> {
  try {
    await storeKit.setItem(key, value);
    console.log(`[${moduleName}] set cache ${key} success`);
  } catch (err:any) {
    console.error(`[${moduleName}] Error setting cache for ${key}: ${err}`);
    throw new RequestError(err.message, EnumCacheErrorCode.IDB_CACHE_SET_ERROR);
  }
}

async function getCache<T>(key: string): Promise<T | RequestError> {
  try {
    return (await storeKit.getItem(key)) as T;
  } catch (err:any) {
    return new RequestError(err.message, EnumCacheErrorCode.IDB_CACHE_GET_ERROR);
  }
}

async function normalizeData<T>(cacheKey: string): Promise<T> {
  const cacheData = await getCache<T>(cacheKey);
  if (cacheData instanceof RequestError) {
    throw cacheData;
  } else if (cacheData === undefined) {
    throw new RequestError(
      'Cache data is undefined for key: ' + cacheKey,
      EnumCacheErrorCode.IDB_CACHE_GET_UNDEFINED_ERROR
    );
  }
  return cacheData;
  // throw new RequestError(
  //   'Cache data is undefined for key: ' + cacheKey,
  //   EnumCacheErrorCode.IDB_CACHE_GET_UNDEFINED_ERROR
  // );
}

export async function fetchWithCache<T>(
  fn: () => Promise<T>,
  cacheKey: string
) {
  try {
    const result = await fn();
    if(result === null){
      reportError({
        retry_reason: 'network_error',
        event_name: 'fetchWithCache',
        retry_path: cacheKey
      });
      return await normalizeData<T>(cacheKey);
    }

    if(isServerError(result)){
      const _result = result as RequestError;
      reportError({
        retry_reason: `server_error_${_result.code}`,
        event_name: 'fetchWithCache',
        retry_path: cacheKey
      });
      return await normalizeData<T>(cacheKey);
    }

    // if (isHttpError(result as RequestError)) {
    //   const _result = result as RequestError;
    //   reportError({
    //     retry_reason: `http_error_${_result.code}`,
    //     event_name: 'fetchWithCache',
    //     retry_path: cacheKey
    //   });
    //   return await normalizeData<T>(cacheKey);
    // }

    setCache(cacheKey, result);
    return result;
  } catch (err:any) {
    console.log('fetchWithCache error:', err);
    reportError({
      retry_reason: err.message,
      event_name: err.message,
      retry_path: cacheKey
    });
  }
}
